let token: string | null = null;

export const setToken = (value?: string | null): void => {
  token = value ?? null;
};

export const getToken = (): string | null => token;

export const clearToken = (): void => {
  token = null;
};
